export class BroadcastTranslation
{
    id: number;
    locale: string;
    sender_name: string;
    subject: string;
    message: string;
}
